import { defineMessages } from 'react-intl';

export default defineMessages({
  storeOnboardingBlocked: {
    description: 'Activation Modal > SSR Authentication Blocked Message',
    defaultMessage: 'We ran into a problem while trying to activate returns for your store. Please contact support for assistance.',
    id: '1+HNCV',
  },
  storeOnboardingBlockedTitle: {
    description: 'Activation Modal > SSR Authentication Blocked Title',
    defaultMessage: 'Returns & Exchanges error',
    id: 'Y9v8m8',
  },
});
